/* lua.js generated code undefined */

_G.DAManager = require("clover/gamePlay/DropAdjust/DAManager")
require("clover/gamePlay/DropAdjust/DAManagerGUILogger")
require("clover/gamePlay/DropAdjust/DATargetCounter")
require("clover/gamePlay/DropAdjust/DATargetCounterV2")
require("clover/gamePlay/DropAdjust/DATargetCountGUILogger")
